import { fromJS, Map } from 'immutable';

export function request(state, { id, payout }) {
    let manualSettlements = state.get('manualSettlements') || Map();

    manualSettlements = manualSettlements.set(id, Map({
        state: 'IN_PROGRESS',
        payout
    }));

    return state.set('manualSettlements', manualSettlements);
}

export function error(state, { id, errors }) {
    let manualSettlements = state.get('manualSettlements') || Map();

    manualSettlements = manualSettlements.set(id, Map({
        state: 'ERROR',
        errors: fromJS(errors)
    }));

    return state.set('manualSettlements', manualSettlements);
}

export function finish(state, { id, data }) {
    let manualSettlements = state.get('manualSettlements') || Map();

    manualSettlements = manualSettlements.set(id, Map({
        state: 'FINISHED'
    }));

    let items = state.get('items') || Map();
    items = items.set(id, fromJS(data));

    return state
        .set('items', items)
        .set('manualSettlements', manualSettlements);
}
